/**
 * Represents the request params to be sent in a POST request to /invite-freelancers
 *
 * @type {object}
 */
export const NEW_INVITE_REQUEST_PARAMS = {
  INVITEES: 'invitees'
};

/**
 * Represents the format for an individual invite object to be sent inside an array
 * with a POST request to /invite-freelancers
 *
 * @type {object}
 */
export const INVITE_OBJECT_PARAMS = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email'
};